import { Injectable, inject } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageService, StorageItem } from '../services/local-storage.service';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CanDeactivateGuard {
  localStorageService = inject(LocalStorageService);

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    this.localStorageService.removeItem(StorageItem.ProjectSearchParams);
    return true;
  }
}
